export default "__VITE_ASSET__BW2RqQNs__"